import React, { useContext, useEffect, useState } from 'react'
import { AddTicketsInput } from '../AddTickets/AddTickets';
import ToasterWithMessage from '../../components/shared-components/toaster';
import { ADDING_MULTIPLE_VENUES_INTO_A_TEAM, ADDING_NEW_VENUE_INTO_A_TEAM, GET_ALL_VENUES_BY_LEAGUEID, GET_LEAGUE_TEAMS_BY_LEAGUE_ID, GET_LEAGUES } from '../AddTickets/api/addTicketsQuery';
import { useLazyQuery, useMutation } from '@apollo/client';
import styles from "../Settings/AppVersion.module.css";
import { Autocomplete, Button, Checkbox, TextField } from "@mui/material";
import addTicketStyles from "../AddTickets/AddTickets.module.css";
import { getAutocompleteStyles } from '../../style/getAutoCompleteStyles';
import CreateVenueModal from './model/VenueModel';
import { globalContext } from '../../Provider/AppProvider';
import { Venue } from '../../helper';

interface TeamList {
    lt_id: string;
    lt_name: string;
}

interface LeagueList {
    l_id: string;
    l_name: string;
    l_type?: string|null;
}

interface VenueList {
    ltv_id: string;
    ltv_name:string;
}

const VenueUpdateLeagueAndTeams = ({
    setPage,
    ticketDetails,
    setTicketDetails,
    page,
    setSearch,
    setResetEvent
}: AddTicketsInput) => {

    const [listOfTeams, setListOfTeams] = useState<any>([]);
    const [searchHomeTeam, setSearchHomeTeam] = useState<TeamList | null>(null);
    const [searchAwayTeam, setSearchAwayTeam] = useState<TeamList | null>(null);
    const [isNextBtnClicked, setIsNextBtnClicked] = useState(false);
    const [listOfLeagues, setListOfLeagues] = useState([]);
    const [listOfVenues, setListOfVenues] = useState([]);
    const [searchVenues, setSearchVenues] = useState<VenueList | null>(null);
    const { globalState, handleGlobalState } = useContext<any>(globalContext)
    const [searchLeagues, setSearchLeagues] = useState<LeagueList | null>(null);
    const { success, error } = ToasterWithMessage();
    const [open, setOpen] = useState(false);
    const [getListOfTeams, {loading}] = useLazyQuery(GET_LEAGUE_TEAMS_BY_LEAGUE_ID, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setListOfTeams(data?.league_teams);
        },
        onError: (err) => {
            console.log("Error at GetListOfTeams", err?.message)
        }
    });
    const [addingNewVenue, { loading: addingloading }] = useMutation(ADDING_MULTIPLE_VENUES_INTO_A_TEAM, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
        const addedCount = data?.insert_league_team_venues?.returning?.length || 0;
        if (addedCount > 0) {
            success(`${addedCount} ${addedCount > 1 ? 'new venues' : 'new venue'} added successfully`);
        } else {
            success("All selected venues already exist");
        }

            const tempState = { ...globalState };
            tempState.eventUpdate.updateEvent = true;
            handleGlobalState(tempState);
},
        onError: (err) => {
            if (
                err?.message?.includes('duplicate key value violates unique constraint') ||
                err?.message?.includes('Uniqueness violation')
            ) {
                error('Venue already exists');
            } else {
                error('Unable to add venue');
            }
        }
    });
    
    const [getListOfLeagues, { loading: leaguesLoading }] = useLazyQuery(GET_LEAGUES, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setListOfLeagues(data?.leagues);
        },
        onError: (err) => {
            console.log(err, "====LIST OF LEAGUES ERROR");
            error(err?.message);
        }
    });


    const [getListOfVenues, { loading: venueLoading }] = useLazyQuery(GET_ALL_VENUES_BY_LEAGUEID, {
        fetchPolicy: "no-cache",
        onCompleted: (data) => {
            setListOfVenues(data?.league_team_venues);
        },
        onError: (err) => {
            console.log(err, "====LIST OF VENUES ERROR");
            error(err?.message);
        }
    });

    function resetState() {
        setSearchHomeTeam(null);
        setSearchAwayTeam(null);
        setListOfTeams([]);
        setSearchVenues(null);
        setTicketDetails(null);
        setResetEvent && setResetEvent(true)
    }
    

    const handleSearchHomeTeam = async (_event: any, value: any) => {
        resetState()
        setSearchHomeTeam(value);
        setTicketDetails({
            ...ticketDetails,
            homeTeamId: value?.lt_id,
            homeTeamName: value?.lt_name,
            leagueType: searchLeagues?.l_type
        })
    }
    

    // const handleSearchAwayTeam = async (_event: any, value: any) => {
    //     setSearchAwayTeam(value);
    //     setTicketDetails({
    //         ...ticketDetails,
    //         awayTeamId: value?.lc_id,
    //         awayTeamName: value?.lc_name
    //     })
    // }

    const handleTeamNext = () => {
        setIsNextBtnClicked(true);

        if (searchLeagues?.l_type?.toLowerCase() === "sports") {
            if (!searchHomeTeam) return error("Home Team is required!");
        }

        setSearch && setSearch((prev: any) => !prev);
        setPage(1);
    };

    const handleSearchVenues = async (_event: any, value: VenueList | null) => {
        setSearchVenues(value);
        console.log(value);
        setTicketDetails({
            ...ticketDetails,
            leagueType: searchLeagues?.l_type,
            venueName: value?.ltv_name,
            venueId: value?.ltv_id,
        })
    }

    const handleSearchLeagues = (_event: any, value: LeagueList | null) => {
        resetState();
        setSearchLeagues(value);
        setTicketDetails({
            ...ticketDetails,
            leagueId: value?.l_id,
            leagueName: value?.l_name,
            leagueType: value?.l_type,
            venueName: null,
            homeTeamId: null,
            homeTeamName: null,
            awayTeamId: null,
            awayTeamName: null,
        })
    }    
const handleAddVenue = (venues: Venue[]) => {
    if (!venues || venues.length === 0) {
        error("Please select at least one venue");
        return;
    }

    let ltId: string | null = null;

    if (searchLeagues?.l_type === "Sports") {
        if (!ticketDetails?.homeTeamId) {
            error("Please select homeTeam");
            return;
        }
        ltId = ticketDetails.homeTeamId;
    } else if (listOfTeams?.[0]?.lt_id) {
        ltId = listOfTeams[0].lt_id;
    }

    if (!ltId) {
        error("No valid team ID found");
        return;
    }

    const venueObjects = venues.map((venue) => ({
        lt_id: ltId,
        ltv_name: venue.av_name,
        av_id: venue.av_id,
    }));

    addingNewVenue({
        variables: {
            venues: venueObjects,
        },
    });
};

    useEffect(() => {
        setTicketDetails({
            ...ticketDetails,
            leagueType: searchLeagues?.l_type
        })
        getListOfLeagues();
    }, [])

    useEffect(() => {
        if(ticketDetails?.leagueId) {
            getListOfTeams({
                variables: {
                    l_id: ticketDetails?.leagueId,
                }
            });
            getListOfVenues({
                variables: {
                    search_string : `%%`,
                    l_id:  ticketDetails?.leagueId
                }
            });
        }
    }, [ticketDetails]);

    useEffect(() => {
        if(ticketDetails && ticketDetails?.homeTeamId && ticketDetails?.homeTeamName) {
            setSearchHomeTeam({
                lt_id: ticketDetails?.homeTeamId,
                lt_name: ticketDetails?.homeTeamName
            });
        }
        if(ticketDetails) {
            setSearchLeagues({
                l_id: ticketDetails?.leagueId,
                l_name: ticketDetails?.leagueName,
                l_type: ticketDetails?.leagueType
                
            })
        }
    }, [page])
  return (
            <div className={styles.textFieldFullMainappversion + ' ' + styles.eventsUpdateFieldsWrap}>
            <div className={styles.submainFieldsWrapper}>
                <div className={addTicketStyles.container + ' ' + addTicketStyles.eventsUpdateFieldExtra}>
                    <div className={styles.titlePlaceholderappversion} style = {{marginBottom: '10px'}}>
                        <b className={styles.AppOs}>Leagues</b>
                    </div>
                    <div>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            sx={getAutocompleteStyles(true)}
                            options={listOfLeagues ?? []}
                            loading={leaguesLoading}
                            value={searchLeagues}
                            onChange={handleSearchLeagues}
                            autoHighlight
                            getOptionLabel={(option: LeagueList) => option.l_name || "-"}
                            isOptionEqualToValue={(option: LeagueList, value: LeagueList) => option.l_id === value.l_id}
                            getOptionKey={(option: LeagueList) => option.l_id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Leagues"
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                </div>
                {
                    isNextBtnClicked && !searchLeagues && <span className={addTicketStyles.errorMessage}>League is required!</span>
                }
                </div>
              {((searchLeagues === null) || (searchLeagues && searchLeagues?.l_type?.toLowerCase() === "sports")) ? (
                <div className={addTicketStyles.container + ' ' + addTicketStyles.eventsUpdateFieldExtra}>
                    <div className={styles.titlePlaceholderappversion} style = {{marginBottom: '10px'}}>
                        <b className={styles.AppOs}>Home Team</b>
                    </div>
                    <div>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            sx={getAutocompleteStyles(true)}
                            options={listOfTeams ?? []}
                            loading={loading}
                            value={searchHomeTeam}
                            onChange={handleSearchHomeTeam}
                            autoHighlight
                            getOptionLabel={(option: TeamList) => option.lt_name || "-"}
                            isOptionEqualToValue={(option: TeamList, value: TeamList) => option.lt_id === value.lt_id}
                            getOptionKey={(option: TeamList) => option.lt_id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Home Team"
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                    </div>
                    {
                        isNextBtnClicked && !searchHomeTeam && <span className={addTicketStyles.errorMessage}>Home Team is required!</span>
                    }
                </div>) :  <div className={addTicketStyles.container + ' ' + addTicketStyles.eventsUpdateFieldExtra}>
                            <div className={styles.titlePlaceholderappversion} style={{ marginBottom: '10px' }}>
                            <b className={styles.AppOs}>Search Venue</b>
                            </div>
                            <div>
                            <Autocomplete
                                disablePortal
                                id="combo-box-search-venue"
                                sx={getAutocompleteStyles(true)}
                                options={listOfVenues ?? []} 
                                loading={venueLoading}
                                value={searchVenues}
                                onChange={handleSearchVenues}
                                autoHighlight
                                getOptionLabel={(option: VenueList) => option.ltv_name || "-"}
                                isOptionEqualToValue={(option: VenueList, value: VenueList) => option.ltv_id === value.ltv_id}
                                getOptionKey={(option: VenueList) => option.ltv_id}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select Venue"
                                    InputLabelProps={{ shrink: true }}
                                />
                                )}
                            />
                            </div>
                            {/* {isNextBtnClicked && !searchVenues && (
                            <span className={addTicketStyles.errorMessage}>Venue is required!</span>
                            )} */}
                        </div>}

                    {/* <div className={addTicketStyles.container + ' ' + addTicketStyles.eventsUpdateFieldExtra}>
                        <div className={styles.titlePlaceholderappversion} style = {{marginBottom: '10px'}}>
                            <b className={styles.AppOs}>Away Team</b>
                        </div>
                        <div>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                sx={getAutocompleteStyles(true)}
                                options={listOfTeams ?? []}
                                loading={loading}
                                value={searchAwayTeam}
                                onChange={handleSearchAwayTeam}
                                autoHighlight
                                getOptionLabel={(option: TeamList) => option.lc_name || "-"}
                                isOptionEqualToValue={(option: TeamList, value: TeamList) => option.lc_id === value.lc_id}
                                getOptionKey={(option: TeamList) => option.lc_id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="Select Away Team"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                        </div>
                        {
                            isNextBtnClicked && !searchAwayTeam && <span className={addTicketStyles.errorMessage}>Away Team is required!</span>
                        }
                    </div> */}

                <div style = {{width: '100%', display: 'flex', marginTop: "25px"}}>
                    <div className={addTicketStyles.updateButtonStyle}>
                        <Button
                        classes={{
                            root: styles.separateStyleReferral
                        }}
                        disableRipple
                        fullWidth
                        type="button"
                        onClick={handleTeamNext}
                        >
                        Submit
                        </Button>
             </div>
                </div>
              {/* { && */}
                  <div style={{ width: '100%', display: 'flex', marginTop: "30px" }}>
                      <div className={
                        !(
                                  (searchLeagues && searchLeagues?.l_type !== 'Sports' && listOfTeams?.[0]?.lt_id) ||
                                  (ticketDetails?.leagueId && ticketDetails?.homeTeamId)
                              ) ? styles.disabledButton : styles.updateButtonStyle} style={{width: 'auto'}}>
                          <Button
                              classes={{
                                  root: !(
                                  (searchLeagues && searchLeagues?.l_type !== 'Sports' && listOfTeams?.[0]?.lt_id) ||
                                  (ticketDetails?.leagueId && ticketDetails?.homeTeamId)
                              ) ? styles.separateStyledisabledUpdateBtn : styles.separateStyleReferral
                              }}
                              disableRipple
                              type="button"
                              onClick={() => setOpen(true)}
                          disabled={
                              !(
                                  (searchLeagues && searchLeagues?.l_type !== 'Sports' && listOfTeams?.[0]?.lt_id) ||
                                  (ticketDetails?.leagueId && ticketDetails?.homeTeamId)
                              )
                          }

                          >
                              Add Venue
                          </Button>
                          <CreateVenueModal
                              open={open}
                              onClose={() => setOpen(false)}
                              onAdd={handleAddVenue}
                          />
                      </div>
                  </div>
              {/* } */}
            </div>


        </div>
  )
}

export default VenueUpdateLeagueAndTeams